/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const getWeekEndingData = params => {

    const buildWeekData = formatGivenDate( params.data.weekEndDate, 'YYYY-MM-DD' );

    return buildWeekData;

};

const colDefs = [

    {
        field: 'weekNumber',
        headerName: 'Week',
        sortable: true,
        filter: true,
        width: 40
    },
    {
        field: 'weekEndDate',
        headerName: 'Ending',
        sortable: true,
        filter: true,
        width: 50,
        valueGetter: getWeekEndingData
    },
    {
        field: 'family',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 50
    },
    {
        field: 'poolPackageCode',
        headerName: 'Pkg Code',
        sortable: true,
        filter: true,
        width: 55
    },
    {
        field: 'poolInventory',
        headerName: 'Pool Inventory',
        sortable: true,
        filter: true,
        width: 63,
        cellRenderer: params => {

            if ( params.value > 0 ) {

                return ( <Link to={`/${params.data.unitName}/pools/pool-inventory-by-pool-pkg-code?packagecode=${params.data.poolPackageCode.trim()}&beginweek=${formatGivenDate( params.data.weekEndDate, 'YYYY-MM-DD' )}&endweek=${formatGivenDate( params.data.weekEndDate, 'YYYY-MM-DD' )}&model=${params.data.model}&family=${params.data.family}`}>{params.value}</Link> );

            }

            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'poolOverride',
        headerName: 'Pool Override',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'poolQuantity',
        headerName: 'Pool Quantity',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'ordersAgainstPool',
        headerName: 'Orders Against Pool',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => {

            if ( params.value > 0 ) {

                return ( <Link to={`/${params.data.unitName}/pools/pool-orders-by-pkg-code?packagecode=${params.data.poolPackageCode}&beginweek=${params.data.weekEndDate}&endweek=${params.data.weekEndDate}&model=${params.data.model}&family=${params.data.family}`}>{params.value}</Link> );

            }

            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'netAvailable',
        headerName: 'Net Available',
        sortable: true,
        filter: true,
        width: 60
    }
];

const PoolAvailabilityTable = props => (

    <section className="atp-search-result-panel pool-availability-result-panel ">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

PoolAvailabilityTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default PoolAvailabilityTable;
